import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../layout/Box.js';
import { HStack, VStack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var StyledHeader = styled(Box)({});
StyledHeader.defaultProps = {
  width: "100%"
};
var Header = function Header(_a) {
  var icon = _a.icon,
    text = _a.text,
    subtitle = _a.subtitle,
    _b = _a.justify,
    justify = _b === void 0 ? "start" : _b,
    _c = _a.align,
    align = _c === void 0 ? "center" : _c,
    _d = _a.spacing,
    spacing = _d === void 0 ? "10px" : _d,
    _e = _a.order,
    order = _e === void 0 ? 2 : _e;
  return React__default.createElement(HStack, {
    justify: justify,
    align: align,
    spacing: spacing
  }, React__default.createElement("span", {
    style: {
      order: order,
      display: order === 1 ? "none" : "initial"
    }
  }, icon), React__default.createElement(Box, {
    style: {
      order: 1,
      marginLeft: order < 1 ? "0px" : "inherit"
    }
  }, React__default.createElement(VStack, {
    align: "flex-start"
  }, text, subtitle)));
};
var CardHeader = function CardHeader(_a) {
  var leftImage = _a.leftImage,
    rightImage = _a.rightImage,
    text = _a.text,
    subtitle = _a.subtitle,
    icon = _a.icon;
  _a.image;
  var justify = _a.justify,
    align = _a.align,
    spacing = _a.spacing,
    rest = __rest(_a, ["leftImage", "rightImage", "text", "subtitle", "icon", "image", "justify", "align", "spacing"]);
  function getOrder() {
    if (leftImage) {
      return 0;
    }
    if (rightImage) {
      return 2;
    }
    return 1;
  }
  return React__default.createElement(StyledHeader, __assign({}, rest), React__default.createElement(Header, {
    text: text,
    order: getOrder(),
    subtitle: subtitle,
    icon: icon,
    justify: justify,
    align: align,
    spacing: spacing
  }));
};
export { CardHeader };